<template>
  <CRow>
    <CCol col="12">
      <CButtonToolbar>
        <CButton size="lg" color="ghost-success" shape="pill" @click="$router.push({name: 'New Style',})"><CIcon size="lg" name="cil-plus"/></CButton>
      </CButtonToolbar>
    </CCol>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CDataTable
            outlined
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :fields="globalStylesUiMeta"
            :items="globalStyles"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            @row-clicked="rowClicked"
            :pagination="{ align: 'center'}"
            @page-change="pageChange"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #updated_at="{item}">
              <td>
                {{item.updated_at ? new Date(item.updated_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
            <template #created_at="{item}">
              <td>
                {{item.created_at ? new Date(item.created_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
            <template #is_default="{item}">
              <td>
                <CIcon v-if="item.is_default === 'true'" size="lg" name="cil-check-alt" class="text-success" />
                <span v-else></span>
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{globalStyles.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'

export default {
  name: 'GlobalStyles',
  data () {
    return {
      activePage: 1,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      globalStyles: state => state.pageBuilder.globalStyles,
      globalStylesUiMeta: state => state.pageBuilder.globalStylesUiMeta,
    }),
  },
  methods: {
    ...mapActions({
      listGlobalStyles: 'pageBuilder/listGlobalStyles',
    }),
    ...mapMutations({
      setGlobalStyles: 'pageBuilder/setGlobalStyles',
    }),
    rowClicked (item) {
      this.$router.push({path: `global-style/${item.invisible_id}`})
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
  },
  created () {
  },
  mounted () {
    this.listGlobalStyles()
  },
  destroyed () {
    this.setGlobalStyles([])
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
}
</script>